import { type PlayerProfileResponse } from '@on3/api';
import { MobileMPU } from 'components/Ads/MobileMPU';
import { PlayerSearch } from 'components/Db/Profile/PlayerSearch';
import { ProfileValuationModule } from 'components/Db/Profile/ProfileValuationModule';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { PlayerNilDeals } from 'components/Nil/DealTracker/PlayerNilDeals';
import { Nil100Module } from 'components/Nil/Nil100Module';
import { Nil100Widget } from 'components/Nil/Nil100Widget';
import { NilSportWidget } from 'components/Nil/NilSportWidget';
import { AdminLink } from 'components/User/AdminLink';
import useAthlete from 'contexts/AthleteProvider';
import type { IPlayerNILPageProps } from 'pages/db/[id]/nil';

import { PlayerHeader } from '../PlayerHeader';
import styles from './PlayerNIL.module.scss';

interface PlayerNILPageProps extends Omit<IPlayerNILPageProps, 'basicInfo'> {}

export const PlayerNIL = ({
  latestValuation,
  valuationGrowth,
  nil100,
  nilHSrankings,
  teamNil100,
  playerDeals,
}: PlayerNILPageProps) => {
  const { athlete } = useAthlete();
  const { list: nil100list } = nil100 || {};
  const { list: teamNil100list } = teamNil100 || {};
  const hasPlayerDeals = !!playerDeals?.list?.length;

  const isHighSchool =
    athlete?.organizationLevel === 'HighSchool' &&
    !!nilHSrankings?.list?.length;
  const isCollege =
    !!teamNil100list?.length && athlete?.organizationLevel === 'College';

  // TODO: update everywhere athlete is passed into a component to pull from context

  return (
    <DatabaseLayout>
      <div className={styles.block}>
        <AdminLink path={`/people/${athlete?.slug}/edit/`} />

        <section className={styles.playerDetail}>
          <header>
            <h1>{athlete?.name}</h1>
            <PlayerSearch />
          </header>
          <PlayerHeader player={athlete as PlayerProfileResponse} />
        </section>

        <section className={styles.nil}>
          <ProfileValuationModule
            latestValuation={latestValuation}
            valuationGrowth={valuationGrowth}
          />
        </section>

        <MobileMPU id="mobile_mpu_middle" incontent />

        <div className={styles.modules}>
          {hasPlayerDeals && (
            <section className={styles.deals}>
              <h2>NIL Deal Tracker</h2>
              <PlayerNilDeals playerDeals={playerDeals} />
            </section>
          )}
          {!!nil100list?.length && (
            <section>
              <Nil100Module list={nil100list?.slice(0, 5)} />
            </section>
          )}
          {isHighSchool && (
            <section>
              <NilSportWidget
                list={nilHSrankings?.list?.slice(0, 5)}
                relatedModel={nilHSrankings?.relatedModel}
              />
            </section>
          )}
          {isCollege && (
            <section>
              <Nil100Widget isTeam list={teamNil100list?.slice(0, 5)} />
            </section>
          )}
        </div>
      </div>
    </DatabaseLayout>
  );
};
